module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("Documentation")]), _vm._v(" "), _c('div', {
    staticClass: "pure-g"
  }, [_c('div', {
    staticClass: "pure-u-5-6 grid__padding--right"
  }, [_c('configurator-input', {
    ref: "documentationUrlInput",
    attrs: {
      "placeholder": 'Documentation Url'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1-6 grid__padding--left"
  }, [_c('vue-r-button', {
    attrs: {
      "label": 'Add',
      "onClick": _vm.addDocumentationUrl
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b6b9b73"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/configuratorDocumentation.vue
// module id = 69
// module chunks = 0